import BottomPanels from './BottomPanels';

export default BottomPanels;
export * from './BottomPanels';
